import { cloneObject } from '../../../../../utils';
import { getFields } from '../../../../../utils/defaultFields';
import masks from '../../../../../utils/masks.json';

const fields = ['email'];

const schema = {
    ...cloneObject(getFields(fields)),
    phoneandcellphon: {
        id: 'phoneandcellphon',
        label: 'Telefone',
        help: '',
        mask: masks.cellphone,
        required: true,
        type: 'text',
        requiredMessage: 'Digite um telefone com o DDD válido',
    },
};

export default schema;
